<template>
  <div class="list">
    <ul>
      <li v-for="item in auditionCourseList" :key="item.MyClassId + 'i' + item.TeacherId" @click="$emit('changeCurPlaying', item)"
        :class="item.MyClassId === curPlaying.MyClassId && item.TeacherId === curPlaying.TeacherId ? 'playing' : ''">
        <p><span><i></i><i></i><i></i></span>{{item.MyClassName}}</p>
        <label>讲师:{{item.Teacher}}</label>
      </li>
    </ul>
    <div class="fun">
      <div class="phone">
        <p v-if="phone">
          <img src="https://img2.233.com/wx/union/pure/pc/video_tel.png">
          <span>咨询电话</span>
        </p>
        <label v-if="phone">{{phone}}</label>
      </div>
      <div class="enroll" @click="ScrollTop">我要报名</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "List",
  props: {
    auditionCourseList: {
      type: Array,
      default: () => []
    },
    curPlaying: {
      type: Object,
      default: () => {}
    },
    phone: {
      type: String,
      default: ""
    }
  },
  methods: {
    ScrollTop() {
      const htmlScrollTop = document.querySelector("body").scrollTop
      const scrollDom = document.querySelector(htmlScrollTop === 0 ? "html" : "body")
      const mealTop = document.querySelector(".meal-flag").getBoundingClientRect().top
      // scrollDom.style.marginTop = -scrollDom.scrollTop + 'px'
      // scrollDom.scrollTop = sssss + lili
      // scrollDom.style.transition = 'all .5s ease-in-out'
      // scrollDom.style.marginTop = sssss + lili
      // setTimeout(() => {
      //   scrollDom.style.transition = 'none'
      // }, 500)
      scrollDom.scrollTop = scrollDom.scrollTop + mealTop
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../assets/css/index.scss";
.list{
  width: 420px;
  height: 100%;
  background: url(https://img2.233.com/wx/union/pure/pc/video_bg.jpg) no-repeat center center;
  padding: 25px 15px 25px 22px;
  box-sizing: border-box;
  ul{
    height: 324px;
    overflow-y: auto;
    padding-right: 20px;
    box-sizing: border-box;
    li{
      list-style: none;
      line-height: 39px;
      display: flex;
      justify-content: space-between;
      height: 39px;
      width: 100%;
      margin-bottom: 12px;
      border-radius: 20px;
      background: #0F0F0F;
      padding: 0 18px;
      box-sizing: border-box;
      cursor: pointer;
      p{
        color: #878787;
        font-size: 15px;
        font-weight: 400;
        width: 250px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        span{
          display: none;width: 11px;height: 13px;vertical-align: middle;margin-left: 6px;margin-top: -2px;position: relative;margin-right: 9px;
          i{
            &:nth-child(1){position: absolute;bottom:0;left: 0;width: 2px;height: 10px;background-color: #fff;animation: bc1 infinite 0.8s linear;}
            &:nth-child(2){position: absolute;bottom:0;left: 5px;width: 2px;height: 6px;background-color: #fff;animation: bc2 infinite 1.0s linear;}
            &:nth-child(3){position: absolute;bottom:0;left: 10px;width: 2px;height: 13px;background-color: #fff;animation: bc3 infinite 1.2s linear;}
          }
          @keyframes bc1{
            0%{height: 10px;}
            50%{height: 0px;}
            100%{height: 10px;}
          }
          @keyframes bc2{
            0%{height: 6px;}
            50%{height: 0px;}
            100%{height: 6px;}
          }
          @keyframes bc3{
            0%{height: 13px;}
            50%{height: 0px;}
            100%{height: 13px;}
          }
        }
      }
      label{
        font-weight: 400;
        font-size: 14px;
        color: #5F5F5F;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        flex: 1;
      }
    }
    .playing{
      @include video_list_playing_background();
      p{
        color: #fff;
        font-weight: bold;
        span{
          display: inline-block;
        }
      }
      label{
        color: #fff;
      }
    }
  }
  ul::-webkit-scrollbar{width: 6px;background: none;border-radius: 30px;}
  ul::-webkit-scrollbar-thumb{ background: #424242;border-radius: 30px;}
  .fun{
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    padding-right: 20px;
    box-sizing: border-box;
    .phone{
      width: 182px;
      text-align: center;
      p{
        margin-bottom: 2px;
        img{
          width: 19px;
          height: 20px;
          margin-right: 5px;
          vertical-align: middle;
        }
        span{
          color: #929191;
          font-size: 18px;
          font-weight: 300;
          vertical-align: middle;
        }
      }
      label{
        color: #fff;
        font-size: 21px;
        font-weight: 300;
      }
    }
    .enroll{
      display: inline-block;
      width: 155px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      @include video_list_button_background();
      font-size: 20px;
      font-weight: 400;
      color: #fff;
      cursor: pointer;
      transition: .2s;
      &:hover{
        transform: translateY(-5px);
      }
    }
  }
}
</style>